import Vue from 'vue';

const defaultSurvey = {
    additionalData: [],
    accountStage: null,
    activeStepper: 1,
    stepperComplete: false,
    showFirstLoginSurveyModal: false,
    address: null,
    section2: {
        active_section: 1,
        disallow_by_pregnant: false,
        disallow_by_breast_cancer: false,
        disallow_by_breast_surgery: false,
        disallow_by_breast_enlargement: false,
        q1: '',
        q2: '',
        q3: '',
        q4: '',
    },
    section3: {
        active_section: 1,
        q2_1_size: '',
        q2_2_size: '',
        q2_1_type_observe: '',
        q2_2_type_observe: '',
        q1: '',
        q2: '',
        q3: '',
        q4: '',
        q5: '',
        q6: '',
        q7: '',
        q8: '',
        q10: '',
        q10_type: '',
        q10_location: '',
        user_weight: null,
        user_height: null,
    },
    section4: {
        active_section: 1,
        q1: '',
        q2: '',
        q2_1: '',
        lastPeriod: '',
        q3: '',
        q4: '',
    },
    section5: {
        active_section: 1,
        q1: '',
        q2: '',
        q3: '',
        name: '',
        second_name: '',
        birth_date: '',
        email: '',
        phone: '',
        pesel: '',
        family_name: '',
        document: '',
        document_id: '',
        nationality: '',
        country: '',
        street: '',
        street_number: '',
        home_number: '',
        postal_code: '',
        city: '',
    },
};

const mapUserSurveyToSurvey = userSurvey => ({
    accountStage: userSurvey.completionStage,
    showFirstLoginSurveyModal: userSurvey.completionStage == null || userSurvey.completionStage === 'DISALLOWED',
});

const state = {
    brasterAllowed: true,
    survey: { ...defaultSurvey },
};

const mutations = {
    RESET_SURVEY: state => Object.assign(state.survey, defaultSurvey),
    STATE_SURVEY: (state, payload) => Object.assign(state.survey, payload),
    BRASTER_PERMISSION: (state, payload) => (state.brasterAllowed = payload.brasterAllowed),
};

const actions = {
    setBrasterPermission: ({ commit }, payload) => commit('BRASTER_PERMISSION', payload),
    fetchUserSurvey: ({ commit }) =>
        new Promise((resolve, reject) =>
            Vue.http.get('/examination/api/other/survey').then(
                ({ data }) => {
                    commit('STATE_SURVEY', mapUserSurveyToSurvey(data));
                    return resolve(data);
                },
                error => reject(error),
            ),
        ),
    updateUserSurvey: ({ commit }, payload) =>
        new Promise((resolve, reject) =>
            Vue.http.post('/examination/api/other/survey', payload).then(
                ({ data }) => {
                    commit('STATE_SURVEY', mapUserSurveyToSurvey(data));
                    resolve(data);
                },
                error => reject(error),
            ),
        ),
};

const getters = {
    survey: state => state.survey,
    brasterAllowed: state => state.brasterAllowed,
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/survey.js